// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".locale-workspace-sub-menu {\n  height: 280px;\n  filter: drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.2));\n  box-shadow: none !important;\n  border-radius: var(--brand-surface-radius, 8px) !important;\n  background-color: var(--v-white-base);\n  padding: 4px 12px;\n}", ""]);
// Exports
module.exports = exports;
